import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const CheckCircleSolid = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18m4.06 6.175a.75.75 0 0 0-1.06.052l-3.974 4.385L9.112 11.5a.75.75 0 1 0-1.111 1.007l2.47 2.727a.75.75 0 0 0 1.112 0l4.53-5a.75.75 0 0 0-.053-1.06"
      clipRule="evenodd"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(CheckCircleSolid) as SvgIcon;
export { ForwardRef as ReactComponent };
